import {
  Alert,
  Box,
  Button,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Toolbar,
  Typography,
} from "@mui/material";
import React,{useState,useEffect} from "react";
import CloseIcon from "@mui/icons-material/Close";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { useDropzone } from "react-dropzone";
import useAxiosPrivate from '../../hooks/useAxiosPrivate'
import styled from "@emotion/styled";
import { useNavigate } from "react-router-dom";
const thumbsContainer = {
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  marginTop: 16
};

const thumb = {
  display: 'flex',
  alignItems:'center',
  borderRadius: 2,
  marginBottom: 8,
  marginRight: 8,
  width: "80%",
  height: "80%",
  padding: 4,
  boxSizing: 'border-box'
};
const thumbInner = {
  display: 'flex',
  minWidth: 0,
  borderRadius:'10px',
  width: "30%",
  height: "40%",
  overflow: 'hidden'
};
const StyledDate=styled('input')(({theme})=>({
    width: '160px',
    height: '44px',
    background:theme.palette.background.default,
    border:`0.2px solid ${theme.palette.third.main}`,
    margin:'20px'
}))
const StyledLabel=styled('label')(({theme})=>({
    fontWeight: '600',
    fontSize: '15px',
    lineHeight: '20px',
}))


function ExtendResearch({ close }) {
  const navigate=useNavigate()
  const api=useAxiosPrivate()
  const [end_date,setEnd_data]=useState()
  const submitImport=()=>{
    api.
    post(`research/sendExtendRequest`,{new_end_date:end_date,
                                        pre_end_date:close.end_date,
                                        research_id:close.id})
    .then((response)=>{
      // console.log(respose)
    const file=new FormData()
    file.append("extension_id",response.data.id)
    file.append("attachment",files[0])
    api
    .post("research/extensionAttachment", file)
    .then((response)=>{
      close.setOpen(false)
      navigate('/researches', {state:{id:close.id,message:"A Research Extension has been requested"}})
      window.location.reload();
    
    })
    })
  }
  const [files, setFiles] = useState(close.file?[close.file]:[]);
  const [errors,setErrors]=useState([])
  const { acceptedFiles, getRootProps, getInputProps, open,    fileRejections, } =  useDropzone({
    accept: {
      'text/plain': ['.pdf']
    },
    maxSize:25000000,
    multiple:false,
    noClick:true,
    onDropAccepted: acceptedFiles => {
      setFiles(acceptedFiles.map(file => Object.assign(file, {
        preview: URL.createObjectURL(file)
      })))},
    onDropRejected: fileRejections => {
      setErrors(fileRejections.map(error => Object.assign(error)));
    },
  });
  const rejected= errors.map(({ file, errors }) => (
    <div style={thumb} key={file.name}>
    <Typography key={file.path} sx={{color:'danger.main',display:'flex',flexWrap:"wrap"}}>
      Error on {file.path} - {Math.round(file.size/1024)} KB
      <ul>
        {errors.map(e => (
          <li key={e.code}>{e.message}</li>
        ))}
      </ul>
 
    </Typography>
         <IconButton sx={{p:'15px'}} onClick={() =>{setErrors([])}}>
            <CloseIcon />
      </IconButton>
    </div>
  ));
  const thumbs = files.map(file => (
    <div style={thumb} key={file.name}>
      <div style={thumbInner}>
        <PictureAsPdfIcon fontSize="large"/>
      </div>
       <Typography key={file.path} sx={{width:"70%"}}>

      Name: {file.path} <br/>
      Size:{Math.round(file.size/1024)} KB
       </Typography>
      <IconButton onClick={() =>{setFiles([])}}>
            <CloseIcon />
      </IconButton>
    </div>
  ));
  useEffect(() => {
    return () => files.forEach(file => URL.revokeObjectURL(file.preview));
  }, []);
  // console.log(end_date)
  return (
    <>
      <Box sx={{ width: "30rem" }}>
        <Toolbar
          sx={{
            borderBottom: "1px solid",
            borderColor: "third.light",
            padding: "0px",
          }}
        >
          <Typography flexGrow={1} sx={{fontWeight:700}}>Extend Research</Typography>
          <IconButton onClick={() => close.setOpen(false)}>
            <CloseIcon />
          </IconButton>
        </Toolbar>
        <Container
          className="container"
          sx={{
            padding: "20px",
            display: "flex",
            flexDirection: "column",
            gap: "0.1rem",
          }}
        >
        <StyledLabel>
            New Expiry Date
        </StyledLabel>
        <StyledDate 
        type="Date"
        name='startDate'
        selected={end_date}
        onChange={(event)=>{setEnd_data(event.target.value)}}
        />
        <Divider/>
        <StyledLabel>
            Upload Attachment
        </StyledLabel>
          <Box
            sx={{
              padding: "20px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: "0.3rem",
            }}
          >
            <Alert
              severity="info"
              color="secondary"
              sx={{ width: "100%", background: "none",fontWeight:600 }}
            >
              Allowed types: .pdf only
            </Alert>
          </Box>
        { files.length===0?
         <Box
            {...getRootProps()}
            sx={{
              padding: "30px",
              border: "2px dashed",
              borderColor: "third.main",
              backgroundColor: "third.light",
            }}
          >
            <input {...getInputProps()} />
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <CloudUploadIcon
                fontSize="large"
                sx={{ color: "primary.main" }}
              />
              <Typography
                variant="subtitle"
                sx={{
                  color: "primary.main",
                  fontWeight: 600,
                  lineHeight: "20px",
                  textAlign: "center",
                }}
              >
                Drop you file here to start uploading
              </Typography>

              <Divider
                orientation="horizontal"
                flexItem
                sx={{
                  fontWeight: 600,
                  color: "third.dark",
                  padding: "0.5rem",
                }}
              >
                OR
              </Divider>
              <Button variant="outlined" color="secondary" onClick={open}>
                Browse
              </Button>
            {rejected.length!==0 && rejected}
            </Box>
          </Box>:
            <Box
            {...getRootProps()}
            sx={{
              padding: "30px",
              border: "2px dashed",
              borderColor: "third.main",
              backgroundColor: "third.light",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                flexWrap:"wrap",
                wordWrap: "break-word",
                padding:"5px"

              }}
            >
                <h4>Selected Document</h4>
                {thumbs}
            </Box>
          </Box>}
          <DialogActions sx={{ marginTop: "1.5rem" }}>
            <Button
              variant="outlined"
              color="third"
              onClick={() => close.setOpen(false)}
            >
              Cancel
            </Button>
            <Button variant="contained" color="secondary" disabled={files.length!==1 || !end_date} onClick={()=>submitImport()}>
              Submit
            </Button>
          </DialogActions>
        </Container>
      </Box>
    </>
  );
}

export default ExtendResearch;
